var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject,attrs:{"id":_vm.id}},[_c('btn',{attrs:{"action":_vm.toggleOpen,"active":_vm.open,"type":"secondary","light":"","header":"","title":_vm.title,"icon":_vm.icon,"href":_vm.link,"src":_vm.src}}),_vm._v(" "),(!!_vm.openDropdown)?_c('dropdown',{attrs:{"items":_vm.items,"header":_vm.header,"footer":_vm.footer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }